<div [formGroup]="loginForm">
    <div>
        <mat-form-field class="mat-field-width"
                floatLabel="always">    
            <mat-label>Email address</mat-label>
            <input matInput type="email"
                appAutoFocus
                placeholder="Email address"
                formControlName="username"
                class="form-control" />
            <mat-error>Valid email required</mat-error>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field class="mat-field-width" floatLabel="always">
            <mat-label>Password</mat-label>
            <input matInput
                type="password"
                formControlName="password"
                placeholder="Your password"
                class="form-control" />
            <mat-error>Required</mat-error>
        </mat-form-field>
    </div>
</div>